import { useState, useEffect } from "react";
import React from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Liveactivitylogs from "./Liveactivitylogs"; // Import the updated component
import GraphDataindashboard from "./GraphDataindashboard";
import bike from "../Collections/bike.jpg";
import car from "../Collections/car.jpg";
import parkingexit from "../Collections/parkingexit.jpg";
import parkingentry from "../Collections/parkingnetry.png";
import openbarrier from "../Collections/openbarriar.png";
import closebarrier from "../Collections/Parki.png";
import lastentryvehile from "../Collections/lastentryvehile.jpg";
import Header from "./Header";

const Dashboard1 = () => {

  const [data, setData] = useState({
    totalCapacity: 0,
    occupied: 0,
    percentage: 0,
  });

  const [entryExitdata, setEntryExitdata] = useState({
    entry: 0,
    exits: 0,
    todayCarEntrycount: 0,
    todayCarExitscount: 0,
    todayBikeEntrycount: 0,
    todayBikeExitscount: 0,
    lastEntryVehicleNumber: "",
    lastExitVehicleNumber: ""
  });

  useEffect(() => {
    const fetchEntryExitData = async () => {
      try {
        const officeId = localStorage.getItem("office_id");
        const token = localStorage.getItem("token")

        if (!officeId) {
          console.error("Office ID not found in localStorage.");
          return;
        }

        if (!token) {
          console.error("Token not found in localStorage.");
          return;
        }
        const response = await axios.get(
          `https://housys.skymarkone.in:8001/api/gettotal-entry-exits/${officeId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setEntryExitdata({
          ...response.data,
          lastEntryVehicleNumber: response.data.lastEntry?.Vehicle?.vehicle_number || "N/A",
          lastExitVehicleNumber: response.data.lastExits?.Vehicle?.vehicle_number || "N/A",
        });

        console.log("Fetched data:", response.data);
      } catch (error) {
        console.error("Error fetching entry/exit data:", error);
      }
    };

    fetchEntryExitData();
    //const interval = setInterval(fetchEntryExitData, 1000);

    //return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchtodaycapacity = async () => {
      try {
        const officeId = localStorage.getItem("office_id");
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("Token not found in localStorage.");
          return;
        }

        const response = await axios.get(`https://housys.skymarkone.in:8001/api/gettotal-accupied/${officeId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.data && response.data.totalOccupied.length > 0) {
          const {
            total_occupied: totalOccupied,
            total_car_capacity: carCapacity,
            total_bike_capacity: bikeCapacity,
          } = response.data.totalOccupied[0];

          const totalCapacity = parseInt(carCapacity) + parseInt(bikeCapacity);
          const occupied = totalOccupied;
          const percentage = (occupied / totalCapacity) * 100;

          setData({ totalCapacity, occupied, percentage });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const intervalId = setInterval(fetchtodaycapacity, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const graphData = {
    todayCarEntrycount: entryExitdata.todayCarEntrycount,
    todayCarExitscount: entryExitdata.todayCarExitscount,
    todayBikeEntrycount: entryExitdata.todayBikeEntrycount,
    todayBikeExitscount: entryExitdata.todayBikeExitscount,
  };

  return (
   <div className="container-fluid px-3 py-2">
      <Header />
      <div className="row mt-2 g-3">
        <div className="col-lg-4">
          {/* Total Capacity Card */}
          <div className="card shadow-sm border-0 mb-3" style={{
            backgroundColor: "#ffffffff",
            borderRadius: "15px",
            height: "280px",
            border: "2px solid #dee2e6"
          }}>
            <div className="card-body d-flex flex-column align-items-center justify-content-center p-3">
              <h5 className="mb-3 text-center" style={{ fontWeight: "600", fontSize: "1.5rem", color: "#212529" }}>
                Total Capacity: {data.totalCapacity}
              </h5>
              <div style={{ width: "180px", height: "180px" }}>
                <CircularProgressbar
                  value={data.percentage}
                  text={`${data.percentage.toFixed(1)}%`}
                  styles={buildStyles({
                    pathColor: "#0080ffff",
                    trailColor: "#dee2e6",
                    textColor: "#212529",
                    textSize: "16px"
                  })}
                />
              </div>
            </div>
          </div>

          {/* Vehicle Count Cards */}
          <div className="row g-2">
            <div className="col-6">
              <div className="card shadow-sm border-0 h-100" style={{
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                border: "2px solid #28a745"
              }}>
                <div className="card-body d-flex flex-column justify-content-between  p-3">
                  <h6 className="mb-2" style={{ fontSize: "1.2rem", fontWeight: "600", color: "#df3232ff" }}>Bikes Today</h6>
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <span className="fs-2 fw-bold mb-1" style={{ color: "#212529" }}>{entryExitdata.todayBikeEntrycount}</span>
                    <img src={bike} alt="Bike" style={{ width: "60px", height: "auto" }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6">
              <div className="card shadow-sm border-0 h-100" style={{
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                border: "2px solid #007bff"
              }}>
                <div className="card-body text-center p-3 d-flex flex-column justify-content-between">
                  <h6 className="mb-2" style={{ fontSize: "1.2rem", fontWeight: "600", color: "#007bff" }}>Cars Today</h6>
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <span className="fs-2 fw-bold mb-1" style={{ color: "#212529" }}>{entryExitdata.todayCarEntrycount}</span>
                    <img src={car} alt="Car" style={{ width: "60px", height: "auto" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-8 d-flex flex-column">
          {/* Stats Cards Row */}
          <div className="row g-2 mb-3">
            <div className="col-6 col-lg-3">
              <div className="card shadow-sm border-0 h-100" style={{
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                border: "2px solid #17a2b8"
              }}>
                <div className="card-body text-center p-3 d-flex flex-column justify-content-between">
                  <h6 className="mb-2" style={{ fontSize: "1.2rem", fontWeight: "600", color: "#17a2b8" }}>Total Entry Today</h6>
                  <div className="d-flex flex-row align-items-center justify-content-around">
                    <span className="fs-2 fw-bold mb-1" style={{ color: "#212529" }}>{entryExitdata.entry}</span>
                    <img src={openbarrier} alt="Entry" style={{ width: "60px", height: "auto" }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6 col-lg-3">
              <div className="card shadow-sm border-0 h-100" style={{
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                border: "2px solid #fd7e14"
              }}>
                <div className="card-body text-center p-3 d-flex flex-column justify-content-between">
                  <h6 className="mb-2" style={{ fontSize: "1.2rem", fontWeight: "600", color: "#fd7e14" }}>Total Exit Today</h6>
                  <div className="d-flex flex-row align-items-center justify-content-around">
                    <span className="fs-2 fw-bold mb-1" style={{ color: "#212529" }}>{entryExitdata.exits}</span>
                    <img src={closebarrier} alt="Exit" style={{ width: "60px", height: "auto" }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6 col-lg-3">
              <div className="card shadow-sm border-0 h-100" style={{
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                border: "2px solid #28a745"
              }}>
                <div className="card-body text-center p-3">
                  <h6 className="mb-2" style={{ fontSize: "1.2rem", fontWeight: "600", color: "#28a745" }}>Last Entry</h6>
                  <div className="d-flex flex-column align-items-center">
                    <span className="fs-4 fw-bold mb-1" style={{ fontSize: "1.2rem", color: "#212529" }}>
                      {entryExitdata.lastEntryVehicleNumber}
                    </span>
                    <img src={lastentryvehile} alt="Last Entry" style={{ width: "60px", height: "auto" }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-6 col-lg-3">
              <div className="card shadow-sm border-0 h-100" style={{
                backgroundColor: "#ffffff",
                borderRadius: "12px",
                border: "2px solid #dc3545"
              }}>
                <div className="card-body text-center p-3">
                  <h6 className="mb-2" style={{ fontSize: "1.2rem", fontWeight: "600", color: "#dc3545" }}>Last Exit</h6>
                  <div className="d-flex flex-column align-items-center">
                    <span className="fs-4 fw-bold mb-1" style={{ fontSize: "1.2rem", color: "#212529" }}>
                      {entryExitdata.lastExitVehicleNumber}
                    </span>
                    <img src={lastentryvehile} alt="Last Exit" style={{ width: "60px", height: "auto" }} />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* RFID Status, Vehicle Detection and Vehicle Lookup Cards */}
          <div className="row g-2 flex-grow-1">
            {/* RFID Status Card */}
            <div className="col-md-4 d-flex">
              {/* <div className="card shadow-sm border-0 flex-fill" style={{
                borderRadius: "15px",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
              }}>
                <div className="card-header border-0 text-white py-2" style={{ backgroundColor: "transparent" }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 d-flex align-items-center" style={{ fontSize: "0.9rem" }}>
                      <i className="bi bi-wifi me-2"></i>
                      RFID Status
                    </h6>
                    <div className="d-flex align-items-center">
                      <span className="small me-1">Devices:</span>
                      <span className="badge bg-light text-dark" style={{ fontSize: '0.7rem' }}>
                        {rfidStatus.length}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="card-body p-2 d-flex flex-column" style={{ backgroundColor: "rgba(255, 255, 255, 1)", borderRadius: "0 0 15px 15px" }}>
                  {rfidStatus.length > 0 ? (
                    <div className="flex-grow-1" style={{ maxHeight: "200px", overflowY: "auto", overflowX: "hidden" }}>
                      <div className="row g-1 ">
                        {rfidStatus.map((device, index) => (
                          <div key={device.id} className="col-6">
                            <div
                              className={`border rounded p-2 ${device.status === 'connected' ? 'border-success bg-light-success' : 'border-danger bg-light-danger'}`}
                              style={{
                                backgroundColor: device.status === 'connected' ? '#d4edda' : '#f8d7da',
                                fontSize: '0.75rem',
                                minHeight: '70px'
                              }}
                            >
                              <div className="d-flex flex-column justify-content-between align-items-start gap-2">
                                <div>
                                  <i className={`bi ${device.status === 'connected' ? 'bi-router' : 'bi-router text-danger'} me-1`}></i>
                                  <strong style={{ fontSize: '0.85rem' }}>{device.ip_address}</strong>
                                </div>
                                <span className={`badge ${device.status === 'connected' ? 'bg-success' : 'bg-danger'}`} style={{ fontSize: '0.8rem' }}>
                                  {device.status}
                                </span>
                                 <small className="text-muted" style={{ fontSize: '0.65rem' }}>
                                Last: {new Date(device.updated_at).toLocaleTimeString('en-US', { 
                                  hour12: false, 
                                  hour: '2-digit', 
                                  minute: '2-digit' 
                                })}
                              </small>
                              </div>
                             
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="text-center text-muted flex-grow-1 d-flex flex-column justify-content-center">
                      <i className="bi bi-exclamation-triangle fs-4 mb-2"></i>
                      <p className="mb-0" style={{ fontSize: '0.8rem' }}>No devices found</p>
                    </div>
                  )}
                </div>
              </div> */}
            </div>

            {/* Vehicle Detection Card */}
            <div className="col-md-4 d-flex">
              <div className="card shadow-sm border-0 flex-fill" style={{
                borderRadius: "15px",
                background: "linear-gradient(135deg, #c13636ff 0%, #bd0000ff 100%)"
              }}>
                {/* <div className="card-header border-0 text-white py-2" style={{ backgroundColor: "transparent" }}>
                  <h6 className="mb-0 d-flex align-items-center" style={{ fontSize: "0.9rem" }}>
                    <i className="bi bi-car-front me-2"></i>
                    Vehicle Detection
                  </h6>
                </div>
                <div className="card-body p-2 d-flex flex-column" style={{ backgroundColor: "rgba(255, 255, 255, 1)", borderRadius: "0 0 15px 15px" }}>
                  {rfidData === "error" ? (
                    <div className="text-center text-danger flex-grow-1 d-flex flex-column justify-content-center">
                      <i className="bi bi-exclamation-triangle fs-4 mb-2"></i>
                      <p className="mb-0" style={{ fontSize: '0.8rem' }}>Error fetching RFID</p>
                    </div>
                  ) : !rfidData ? (
                    <div className="text-center text-muted flex-grow-1 d-flex flex-column justify-content-center">
                      <i className="bi bi-search fs-4 mb-2"></i>
                      <p className="mb-0" style={{ fontSize: '0.8rem' }}>No vehicle detected</p>
                    </div>
                  ) : (
                    <div className="table-responsive flex-grow-1" style={{ minHeight: "80px", maxHeight: "200px", overflowY: "auto" }}>
                      <table className="table table-sm table-hover mb-0 border">
                        <thead className="table-light sticky-top">
                          <tr>
                            <th style={{ fontSize: '0.75rem', padding: '0.3rem' }}>Tag Number</th>
                            <th style={{ fontSize: '0.75rem', padding: '0.3rem' }}>Gate</th>
                            <th style={{ fontSize: '0.75rem', padding: '0.3rem' }}>Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rfidData.map((item, idx) => (
                            <tr key={idx} className={selectedRFID?.Tag_Number === item.Tag_Number ? "table-primary" : ""}>
                              <td style={{ padding: '0.3rem' }}>
                                <div className="form-check">
                                  <input
                                    type="checkbox"
                                    checked={selectedRFID?.Tag_Number === item.Tag_Number}
                                    onChange={() => setSelectedRFID(item)}
                                    className="form-check-input me-1"
                                    style={{ transform: 'scale(0.8)' }}
                                  />
                                  <span className="fw-bold" style={{ fontSize: '0.75rem' }}>{item.Tag_Number}</span>
                                </div>
                              </td>
                              <td style={{ padding: '0.3rem' }}>
                                <span className="badge bg-primary" style={{ fontSize: '0.6rem' }}>{item.Gate_Name}</span>
                              </td>
                              <td className="small" style={{ padding: '0.3rem', fontSize: '0.65rem' }}>
                                {new Date(item.createdAt).toLocaleTimeString()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div> */}
              </div>
            </div>

            {/* Vehicle Lookup Card */}
            <div className="col-md-4 d-flex">
              <div className="card shadow-sm border-0 flex-fill" style={{
                borderRadius: "15px",
                background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
              }}>
                {/* <div className="card-header border-0 text-white py-2" style={{ backgroundColor: "transparent" }}>
                  <h6 className="mb-0 d-flex align-items-center" style={{ fontSize: "0.9rem" }}>
                    <i className="bi bi-search me-2"></i>
                    Vehicle Lookup
                  </h6>
                </div>
                <div className="card-body p-2 d-flex flex-column" style={{ backgroundColor: "rgba(255,255,255,0.95)", borderRadius: "0 0 15px 15px" }}>
                  <div className="input-group mb-2">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Enter vehicle number"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ borderRadius: "6px 0 0 6px", fontSize: '0.8rem' }}
                    />
                    <button
                      className="btn btn-primary btn-sm"
                      type="button"
                      onClick={handleSearch}
                      style={{ borderRadius: "0 6px 6px 0" }}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                  </div>

                  <div className="flex-grow-1 d-flex flex-column" style={{ minHeight: "80px", maxHeight: "200px", overflowY: "auto" }}>
                    {vehicleResults.length > 0 ? (
                      <div className="flex-grow-1">
                        {vehicleResults.map((v, idx) => (
                          <div
                            key={idx}
                            className={`border rounded p-2 mb-1 cursor-pointer ${selectedVehicle?.vehicle_number === v.vehicle_number ? 'border-primary bg-light' : 'border-light'}`}
                            onClick={() => handleSelect(v)}
                            style={{ cursor: "pointer", fontSize: "0.95rem" }}
                          >
                            <div className="d-flex justify-content-between align-items-center mb-1">
                              <div>
                                <input
                                  className="form-check-input me-1"
                                  type="radio"
                                  name="vehicle"
                                  checked={selectedVehicle?.vehicle_number === v.vehicle_number}
                                  onChange={() => handleSelect(v)}
                                  style={{ transform: 'scale(0.8)' }}
                                />
                                <strong style={{ fontSize: '0.95rem' }}>{v.vehicle_number}</strong>
                                <small className="text-muted">({v.vehicle_type})</small>
                              </div>
                              <span className="badge bg-info px-1" style={{ fontSize: '0.8rem' }}>
                                {v.office_name}
                              </span>
                            </div>
                            <div className="small text-muted mb-1" style={{ fontSize: '0.9rem' }}>
                              <div><strong>Tag:</strong> {v.Tag_no || 'N/A'}</div>
                              <div><strong>Owner:</strong> {v.user_name}</div>
                            </div>
                            <div className="row g-1">
                              <div className="col-6">
                                <div className="small text-success" style={{ fontSize: '0.9rem' }}>
                                  <i className="bi bi-box-arrow-in-right me-1"></i>
                                  <strong>Entry:</strong>
                                  <div>{v.last_entry_time ? (() => {
                                    // Parse the ISO string directly without timezone conversion
                                    const isoString = v.last_entry_time;
                                    const datePart = isoString.split('T')[0];
                                    const timePart = isoString.split('T')[1].split('.')[0];
                                    const [year, month, day] = datePart.split('-');
                                    const [hours24, minutes, seconds] = timePart.split(':');
                                    
                                    let hours = parseInt(hours24);
                                    const ampm = hours >= 12 ? 'PM' : 'AM';
                                    hours = hours % 12;
                                    hours = hours ? hours : 12;
                                    const hoursStr = String(hours).padStart(2, '0');
                                    
                                    return `${day}/${month}/${year} ${hoursStr}:${minutes} ${ampm}`;
                                  })() : 'N/A'}</div>
                                </div>
                              </div>
                              <div className="col-6">
                                <div className="small text-danger" style={{ fontSize: '0.9rem' }}>
                                  <i className="bi bi-box-arrow-right me-1"></i>
                                  <strong>Exit:</strong>
                                  <div>{v.last_exit_time && !v.last_exit_time.includes('00:00:00') ? (() => {
                                    // Parse the ISO string directly without timezone conversion
                                    const isoString = v.last_exit_time;
                                    const datePart = isoString.split('T')[0];
                                    const timePart = isoString.split('T')[1].split('.')[0];
                                    const [year, month, day] = datePart.split('-');
                                    const [hours24, minutes, seconds] = timePart.split(':');
                                    
                                    let hours = parseInt(hours24);
                                    const ampm = hours >= 12 ? 'PM' : 'AM';
                                    hours = hours % 12;
                                    hours = hours ? hours : 12;
                                    const hoursStr = String(hours).padStart(2, '0');
                                    
                                    return `${day}/${month}/${year} ${hoursStr}:${minutes} ${ampm}`;
                                  })() : 'Not Exited'}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="flex-grow-1 d-flex align-items-center justify-content-center text-muted">
                        <div className="text-center">
                          <i className="bi bi-car-front fs-4 mb-2"></i>
                          <p className="mb-0" style={{ fontSize: '0.8rem' }}>Search for vehicles above</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Live Activity Logs */}
      <div className="row mt-2">
        <div className="col-12">
          <Liveactivitylogs />
        </div>
      </div>
    </div>
  );
};

export default Dashboard1;
